import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import CompanyUserCreateForm from '@src/features/company/company-user/CompanyUserCreateForm';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyUserCreate() {
  return (
    <CompanyGuard canRoles={[COMPANY_ROLE.ADMIN]}>
      <CompanyDefaultLayout pageName='users'>
        <CommonHelmet />
        <CompanyUserCreateForm />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyUserCreate;
